module.exports = __webpack_public_path__ + "img/text1.605232f1.png";